export default "__VITE_ASSET__f015d958__"